<template>
  <div
    v-if="!isPremium && totalCount > 2 && totalCount - referrals.length > 1"
    class="mt-3 alert alert-warning font-weight-bold m-3"
    @click.prevent.stop="withPremium"
    style="cursor: pointer"
  >
    <span v-if="totalCount == referrals.length">See all your referrals with our Premium plan</span>
    <div v-else>
      <b class="d-block mb-1"
        >{{ totalCount - referrals.length }} hidden referral{{ totalCount - referrals.length == 1 ? '' : 's' }}</b
      >
      <p>Get an unlimited viewing window and access all {{ totalCount }} of your referrals with Refera Premium</p>
    </div>
    <a class="font-weight-bolder btn btn-warning d-block mt-1" href="javascript:void(0);">Upgrade now</a>
  </div>
</template>

<script>
import { mapState } from 'vuex'
export default {
  computed: {
    isPremium() {
      return this.$store.getters['billing/isPremium']
    },
    ...mapState('referrals', ['referrals', 'totalCount']),
  },
}
</script>

<style>
</style>